import springApi, { getDomain } from '../../services/springApi'

export const getFaqs = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/faqs', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getFaq = (id, params) => (
	new Promise((resolve, reject) => {
		springApi()
			.get(`/faqs/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeFaq = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/faqs', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateFaq = (id, data) => (
	new Promise((resolve, reject) => {
		springApi()
			.put(`/faqs/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteFaq = id => (
	new Promise((resolve, reject) => {
		springApi()
			.delete(`/faqs/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const searchFaqs = async (term, token) => (
	fetch( getDomain()+`/faqs?filter[keywords]=${term}`, {
		headers: {'Authorization': `Bearer ${token}`}
	})
		.then((response) => response.json())
		.then((res) =>
			res.data.map(faq => ({
				label: faq.question,
				value: faq.id,
			})),
		)
)

export const toggleDepartment = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/department_faq', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const toggleOnAllDepartments = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/department_faq/all_on', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)